<template>
  <div class="wrapper main-color">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/admin/dashboard" v-if="authedUser.isadmin" name="Dashboard" icon="ti-panel"/>
        <!-- <sidebar-link to="/stats" name="User Profile" icon="ti-user"/>
        <sidebar-link to="/table-list" name="Table List" icon="ti-view-list-alt"/>
        <sidebar-link to="/typography" name="Typography" icon="ti-text"/>
        
        <sidebar-link to="/maps" name="Map" icon="ti-map"/>
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell"/> -->
        <sidebar-link to="/user/items" v-if="authedUser.isadmin==false" name="Items" icon="ti-user"/>
        <sidebar-link to="/admin/users" v-if="authedUser.isadmin" name="Users" icon="fa fa-user"/>

        <sidebar-link to="/admin/categories" v-if="authedUser.isadmin" name="Categories" icon="fa fa-briefcase"/>
        <sidebar-link to="/admin/inventory" v-if="authedUser.isadmin" name="Inventory Items" icon="fa fa-archive"/>
        <sidebar-link to="/admin/quotes" v-if="authedUser.isadmin" name="Quotes" icon="ti-view-grid"/>
        <!-- <sidebar-link to="/music-library" name="Music Library" icon="fa fa-music"/> -->
      </template>
      <mobile-menu>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li> -->
        <!-- <drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down> -->
        <li @click="logout" class="nav-item">
          <a class="nav-link">
            <i class="ti-power-off"></i>
            <p>Logout</p>
          </a>
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import {mapGetters} from 'vuex'
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  computed:{
    ...mapGetters(['authedUser'])
  },
  methods: {
    logout() {
      // this.$router.push({path: '/login'})
      this.$store.dispatch("signoutrequests")
      location.reload();

    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>

<style >
</style>
